export const isUsingCustomHours = ({
  own_availability_rule: ownRule,
  active_availability_rule_id: activeRuleId
}) => {
  const userOwnAvailabilityRule = ownRule || {}
  const userActiveAvailabilityRuleId = activeRuleId

  if (!userActiveAvailabilityRuleId) { return false }

  return (userActiveAvailabilityRuleId === userOwnAvailabilityRule.id)
}
